import styled from 'styled-components';

const MyDiv = styled.div`
  .card {
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    background: #fff;
    padding: 12px 6px 6px 6px;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  }

  .employee-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

.Badge{
border-radius: 16px;
text-decoration:underline;
display: flex;
align-items:center;
gap:4px;

}
  .desig {
    color: rgba(0, 122, 255, 1);
  }
  .branch {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    gap: 12px;
  }
  .btn {
    cursor: pointer;
  }
`;

export default MyDiv;
